import { ITicket } from "../TicketPage"

export const totalPrice = (tickets: ITicket[]) => {
    const total = tickets.reduce(
        (partialSum, ticket) => Math.round(ticket.brackets[0].price_incl_vat) * ticket.count + partialSum,
        0
    );
    return total;
}